import cs from 'classnames';
import { FC, ReactNode } from 'react';
import { characters } from './constants';
import styles from './index.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';

interface ICharacterCard {
  character: string;
  setCharacter: (val: string) => void;
}

const CharacterCard: FC<ICharacterCard> = ({ character, setCharacter }) => {
  return (
    <div className={styles['card']}>
      <Swiper spaceBetween={24} slidesPerView={'auto'}>
        {characters.map((item, index) => (
          <SwiperSlide key={index} style={{ width: '160px' }}>
            <div
              className={cs([
                styles['character_card'],
                item.title === character ? styles['active'] : '',
              ])}
              onClick={() => setCharacter(item.title)}>
              <div className={styles.image_container}>
                <img src={item.image} alt="Character Image" />
              </div>
              <span className={styles['title']}>{item.title}</span>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default CharacterCard;
